import {useEffect, useState} from "react";
import {ERR_MESSAGES} from "../../../utils/constants";
import {defaultRulesInitialDataState} from "../Rules.model";
import {
  CancelToken,
  getMembersRequest,
  getRulesRequest,
  getTelegramChatsRequest,
  groupCancelSource
} from "../../../services/api";

const useDefaultRulesData = () => {
  const [defaultRulesData, setDefaultRulesData] = useState(defaultRulesInitialDataState);

  const updateDefaultRulesData = (showSpinner = false) => {
    return Promise.all([getRulesRequest({showSpinner: showSpinner}), getMembersRequest(showSpinner), getTelegramChatsRequest(showSpinner)])
      .then(([rulesResponse, membersResponse, telegramChatsResponse]) => {
          setDefaultRulesData({
            members: membersResponse.data,
            rules: rulesResponse.data,
            telegramChats: telegramChatsResponse.data
          });
        }
      );
  };

  useEffect(() => {
    groupCancelSource.value = CancelToken.source();
    updateDefaultRulesData(true);

    return () => {
      groupCancelSource.value?.cancel(ERR_MESSAGES.CANCELLED_REQUEST);
      groupCancelSource.value = null;
    };
  }, []);

  return {defaultRulesData, updateDefaultRulesData};
};

export default useDefaultRulesData;